import { useEffect, useState } from 'react';
import AppManagerClient from '../../api/AppManagerClient';
import { IManagingLinuxServiceInstance } from '../../api/models';
import { LinuxServicesServerManagementView } from './LinuxServicesServerManagementView';
import { AccordionWrapper } from '../UIExtentions/Accordion';
import { LinuxServiceEnvironmentComparison } from '../Comparison/LinuxServiceEnvironmentComparison';
import { Stack } from 'react-bootstrap';
import { UserPrincipal } from '../../permissions/userPrincipal';

interface LinuxServicesServerManagementProps {
    applicationName: string;
    userPrincipal: UserPrincipal;
}
export const LinuxServicesServerManagement = ({ applicationName, userPrincipal }: LinuxServicesServerManagementProps) => {
    const [serverApps, setServerApps] = useState(Array<IManagingLinuxServiceInstance>());
    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getLinuxServiceForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <Stack gap={3}>
            <AccordionWrapper
                fitToSize={true}
                headerIcon="fa-code-compare"
                headerText="Environment Comparison"
                objectName={applicationName}
                isLoading={isLoading}
                errorMessage={errorMessage}
            >
                <LinuxServiceEnvironmentComparison data={serverApps} />
            </AccordionWrapper>

            <LinuxServicesServerManagementView
                serverApps={serverApps}
                userPrincipal={userPrincipal}
                isLoading={isLoading}
                errorMessage={errorMessage}
                isDataNotFound={serverApps.length === 0}
                applicationName={applicationName}
            />
        </Stack>
    );
};
